/// <reference types="google.maps" />
import { filter } from 'rxjs/operators';
import { ImageViewerComponent } from 'src/app/component/image-viewer/image-viewer/image-viewer.component';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';

import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Geolocation, Geoposition } from '@awesome-cordova-plugins/geolocation/ngx';
import { IonicModule, IonRouterOutlet, ModalController } from '@ionic/angular';
import { PipesModule } from '@root/app/pipes/pipes.module';
import { Bus, TripRoute, TripStop, User } from '@shared/models';

@Component({
  selector: 'app-route-map',
  templateUrl: './route-map.page.html',
  styleUrls: ['./route-map.page.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, PipesModule],
  providers: [Geolocation],
})
export class RouteMapPage implements OnInit {
  @ViewChild('map', { static: false }) mapElement!: ElementRef;
  map!: google.maps.Map;
  directionsService!: google.maps.DirectionsService;
  directionsDisplay!: google.maps.DirectionsRenderer;
  mapLoaded = false;
  locations: TripStop[] = [];
  markersArray: google.maps.Marker[] = [];
  route: TripRoute | null = null;
  normalIcon: google.maps.Icon | google.maps.Symbol = {
    path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
    fillColor: 'red',
    fillOpacity: 0.6,
    strokeWeight: 0,
    rotation: 0,
    scale: 2,
    anchor: new google.maps.Point(10, 10),
  };
  activeIcon: google.maps.Icon | google.maps.Symbol = this.normalIcon;
  currentStop: TripStop | null = null;
  hideRouteCard = false;
  selfmarker: google.maps.Marker | null = null;
  busMarker: google.maps.Marker | null = null;
  busMarkers: google.maps.Marker[] = [];
  status = false;
  bus: Bus | null = null;
  buses: Bus[] = [];
  user: User | null = null;
  transportec = false;
  gettingSnappedRoute = false;
  busLocationIntervalstarted = false;
  busLocationInterval?: number;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private geolocation: Geolocation,
    private dataService: DataService,
    private modalCtrl: ModalController,
    private auth: AuthService,
    private apiService: ApiService,
    private http: HttpClient,
    private routerOutlet: IonRouterOutlet
  ) {}

  ngOnInit() {
    if (this.activatedRoute.snapshot.data['special']) {
      this.route = this.activatedRoute.snapshot.data['special'];
    } else {
      this.router.navigate(['/tecservice/expresotec/routes']);
    }

    this.auth.getUser().then((user) => {
      this.user = user;
    });

    if (this.route) {
      if (typeof google !== 'undefined') {
        if (this.route.icon) {
          this.normalIcon = {
            url: this.route.icon,
            scaledSize: new google.maps.Size(40, 40), // scaled size
            origin: new google.maps.Point(0, 0), // origin
            anchor: new google.maps.Point(20, 20), // anchor
          };
          this.activeIcon = {
            url: this.route.icon,
            scaledSize: new google.maps.Size(40, 40), // scaled size
            origin: new google.maps.Point(0, 0), // origin
            anchor: new google.maps.Point(20, 20), // anchor
          };
        }
        setTimeout(() => {
          this.loadMap();
        }, 0);
      }

      if (this.router.url.indexOf('transportec') >= 0) {
        this.transportec = true;
      }
    }
  }

  ionViewDidEnter() {
    this.routerOutlet.swipeGesture = false;
  }
  ionViewWillLeave() {
    this.routerOutlet.swipeGesture = true;
    this.endBusLocationInterval();
  }

  snapToRoute(bus: Bus) {
    this.gettingSnappedRoute = true;
    this.http
      .get(
        'https://roads.googleapis.com/v1/snapToRoads?path=' +
          bus.lat +
          ',' +
          bus.long +
          '&key=AIzaSyB2lZbZX7TcIQVwP2wn_bQSLURCAErlLhw'
      )
      .toPromise()
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then((res: any) => {
        const snappedRoute = res?.snappedPoints[0];
        this.drawMarker(bus, snappedRoute?.location?.latitude, snappedRoute?.location?.longitude);
      })
      .finally(() => {
        this.gettingSnappedRoute = false;
      });
  }

  drawMarker(bus: Bus, lat = bus.lat, long = bus.long) {
    const busPosition = new google.maps.LatLng(+lat, +long);
    this.map.setZoom(16);
    this.map.setCenter(busPosition);

    const markerIcon = {
      // url: '/assets/icon/location.gif',
      url: '/assets/icon/expreso.svg',
      // url: 'http://24.media.tumblr.com/0843bd3a76e38ea60e1e926529382dc2/tumblr_n0bz5nRgp81svwlszo1_r1_250.gif',
      scaledSize: new google.maps.Size(35, 35), // scaled size
      origin: new google.maps.Point(0, 0), // origin
      anchor: new google.maps.Point(20, 20), // anchor
    };
    const marker = new google.maps.Marker({
      map: this.map,
      position: busPosition,
      icon: markerIcon,
      zIndex: 99999,
    });

    this.busMarkers.push(marker);
  }

  showBus() {
    this.status = true;
    this.clearBusMarkers();
    for (let i = 0; i < this.buses.length; i++) {
      // this.snapToRoute(this.buses[i]);
      this.drawMarker(this.buses[i]);
    }
  }

  showBus2() {
    if (!this.bus) {
      return;
    }
    this.status = true;
    const busPosition = new google.maps.LatLng(+this.bus.lat, +this.bus.long);
    this.map.setZoom(16);
    this.map.setCenter(busPosition);
    if (this.busMarker != null) {
      this.busMarker.setPosition(busPosition);
    } else {
      const markerIcon = {
        // url: '/assets/icon/location.gif',
        url: '/assets/icon/expresotec.svg',
        // url: 'http://24.media.tumblr.com/0843bd3a76e38ea60e1e926529382dc2/tumblr_n0bz5nRgp81svwlszo1_r1_250.gif',
        scaledSize: new google.maps.Size(30, 30), // scaled size
        origin: new google.maps.Point(0, 0), // origin
        anchor: new google.maps.Point(20, 20), // anchor
      };
      this.busMarker = new google.maps.Marker({
        map: this.map,
        animation: google.maps.Animation.DROP,
        position: busPosition,
        icon: markerIcon,
      });
    }
  }

  getBus() {
    for (let i = 0; i < this.buses.length; i++) {
      this.apiService.getData('bus_location?bus_id=' + this.buses[i].id).then((data) => {
        console.log('location bus: ', data);
        if (data.bus) {
          this.bus = data.bus;
          this.buses[i] = data.bus;
        }
        if (i === this.buses.length - 1) {
          this.showBus();
        }
      });
    }
  }

  startBusLocationInterval() {
    this.busLocationIntervalstarted = true;
    this.endBusLocationInterval();
    this.getBus();
    this.busLocationInterval = window.setInterval(() => {
      this.getBus();
    }, 5000);
  }

  endBusLocationInterval() {
    if (this.busLocationInterval) {
      this.busLocationIntervalstarted = false;
      clearInterval(this.busLocationInterval);
    }
  }

  loadMap() {
    if (!this.route) {
      return;
    }
    this.mapLoaded = true;
    const latLng =
      this.route?.stops[0]?.lat && this.route?.stops[0]?.long
        ? new google.maps.LatLng(+this.route.stops[0].lat, +this.route.stops[0].long)
        : new google.maps.LatLng(19.017669771131203, -98.2395087491928);
    const mapOptions = {
      center: latLng,
      zoom: 14,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: [
        {
          featureType: 'poi',
          stylers: [{ visibility: 'off' }],
        },
        {
          featureType: 'transit',
          elementType: 'labels.icon',
          stylers: [{ visibility: 'off' }],
        },
      ],
    };

    this.directionsService = new google.maps.DirectionsService();
    this.directionsDisplay = new google.maps.DirectionsRenderer({
      suppressMarkers: true,
      polylineOptions: {
        strokeColor: this.route?.color || '#000',
        strokeOpacity: 0.8,
      },
    });
    this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    this.directionsDisplay.setMap(this.map);
    if (this.route) {
      this.getLocations();
    }
  }

  getLocations() {
    if (!this.route) {
      return;
    }
    this.apiService.getData('route/' + this.route.id).then(
      (res) => {
        if (res && res.data) {
          this.route = res.data[0];
          res.data = res.data[0].stops;
          const buses = this.route?.buses;
          if (buses && buses.length) {
            this.bus = buses[0];
            this.buses = buses.filter((bus) => bus.lat && bus.long);
          }

          if (res.data && res.total !== this.locations.length) {
            this.clearOverlays();
            this.locations = res.data;
            this.calculateAndDisplayRoute();

            for (const item of res.data) {
              this.addMarker(item.lat, item.long, item);
            }
          }
        }
      },
      (err) => {
        console.log(JSON.stringify(err));
      }
    );
  }

  async viewImage(src: string, title: string = '', description: string = '') {
    const modal = await this.modalCtrl.create({
      component: ImageViewerComponent,
      componentProps: {
        imgSource: src,
        imgTitle: title,
        imgDescription: description,
      },
      cssClass: 'modal-fullscreen',
      keyboardClose: true,
      showBackdrop: true,
    });

    return await modal.present();
  }

  calculateAndDisplayRoute() {
    const waypts = [];
    const locationsSize = this.locations.length;
    for (let i = 0; i < locationsSize; i++) {
      if (i !== 0 && i !== locationsSize - 1) {
        waypts.push({
          location: new google.maps.LatLng(+this.locations[i].lat, +this.locations[i].long),
          stopover: true,
        });
      }
      if (i === 22) {
        break;
      }
    }
    this.directionsService.route(
      {
        origin: new google.maps.LatLng(+this.locations[0].lat, +this.locations[0].long),
        destination: new google.maps.LatLng(
          +this.locations[locationsSize - 1].lat,
          +this.locations[locationsSize - 1].long
        ),
        waypoints: waypts,
        optimizeWaypoints: true,
        travelMode: google.maps.TravelMode.DRIVING,
      },
      (response, status) => {
        if (status === 'OK') {
          this.directionsDisplay.setDirections(response);
        } else {
          window.alert('Directions request failed due to ' + status);
        }
      }
    );
  }

  locate(lat: number, lng: number) {
    const latLng = new google.maps.LatLng(lat, lng);
    this.map.setCenter(latLng);
  }

  addMarker(lat: number, long: number, element: TripStop) {
    const marker = new google.maps.Marker({
      map: this.map,
      animation: google.maps.Animation.DROP,
      position: new google.maps.LatLng(lat, long),
      icon: this.normalIcon,
    });

    this.markersArray.push(marker);
    this.markerOnclick(marker, element);
  }

  updateLocation() {
    this.map.setZoom(16);
    this.geolocation
      .getCurrentPosition({
        timeout: 5000,
        enableHighAccuracy: true,
        maximumAge: 10000,
      })
      .then((resp) => {
        const latLng = new google.maps.LatLng(resp.coords.latitude, resp.coords.longitude);
        this.map.setCenter(latLng);
      })
      .catch((error) => {
        // this.presentToast('Error getting location:'+ JSON.stringify(error));
        navigator.geolocation.getCurrentPosition((resp) => {
          // this.presentToast("Lat: "+resp.coords.latitude+' Long:'+resp.coords.longitude);
          const latLng = new google.maps.LatLng(resp.coords.latitude, resp.coords.longitude);
          this.map.setCenter(latLng);
        });
      });

    this.geolocation
      .watchPosition()
      .pipe(
        filter((p): p is Geoposition => 'coords' in p && p.coords !== undefined) // Filter Out Errors
      )
      .subscribe((position) => {
        const userPosition = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        if (this.selfmarker != null) {
          this.selfmarker.setPosition(userPosition);
          console.log('Location updated', position);
        } else {
          const markerIcon = {
            url: '/assets/icon/location.gif',
            scaledSize: new google.maps.Size(20, 20), // scaled size
            origin: new google.maps.Point(0, 0), // origin
            anchor: new google.maps.Point(20, 20), // anchor
          };
          this.selfmarker = new google.maps.Marker({
            map: this.map,
            animation: google.maps.Animation.DROP,
            position: userPosition,
            icon: markerIcon,
          });
        }
      });
  }

  clearBusMarkers() {
    for (const myMarker of this.busMarkers) {
      myMarker.setMap(null);
    }

    this.busMarkers.length = 0;
  }

  clearOverlays() {
    for (const myMarker of this.markersArray) {
      myMarker.setMap(null);
    }

    this.markersArray.length = 0;
    this.currentStop = null;
  }

  addInfoWindow(marker: google.maps.Marker, myContent: string) {
    const infoWindow = new google.maps.InfoWindow({
      content: myContent,
    });

    google.maps.event.addListener(marker, 'click', () => {
      infoWindow.open(this.map, marker);
    });
  }

  markerOnclick(marker: google.maps.Marker, element: TripStop) {
    google.maps.event.addListener(marker, 'click', () => {
      this.currentStop = element;
      // }
      this.hideRouteCard = true;

      for (const myMarker of this.markersArray) {
        myMarker.setIcon(this.normalIcon);
      }
      marker.setIcon(this.activeIcon);
      this.map.panTo(marker.getPosition() as google.maps.LatLng);
    });
  }

  dismiss() {
    // this.viewCtrl.dismiss();
  }

  goStops() {
    if (!this.route) {
      return;
    }
    this.dataService.setData(this.route.id, this.route);
    if (this.router.url === '/tecservice-transportec/transportec/route-map/' + this.route.id) {
      this.router.navigate(['/tecservice-transportec/transportec/route', this.route.id]);
    } else {
      this.router.navigate(['/tecservice/expresotec/route', this.route.id]);
    }
  }
}
